(() => {
  // Preserve the theme's image descriptions when an app returns a missing translation.
  const images = document.querySelectorAll('.c-logo img, .mxpro-hero img, .mxpro-category-card img, .mxpro-partner img, .mxpro-visit img, .c-brands__image');
  images.forEach((image) => {
    const original = image.closest('.c-logo')?.getAttribute('aria-label') || image.alt;
    if (!original || original === 'undefined' || original === 'null') return;
    const restoreDescription = () => {
      if (!image.alt || image.alt === 'undefined' || image.alt === 'null') image.alt = original;
    };
    restoreDescription();
    new MutationObserver(restoreDescription).observe(image, { attributes: true, attributeFilter: ['alt'] });
  });
})();
